import React, { useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';
import Loader from './common/Loader';

function TaskHistoryFollowUp({ followUp }) {
  return (
    <li className="list-group-item py-3">
      <div className="d-flex align-items-start">
        <div
          className="text-nowrap fw-semibold pe-4 text-muted"
          style={{ fontSize: '1.05rem', minWidth: '11rem' }}
        >
          {followUp.date}
        </div>
        <div className="flex-grow-1">
          <h6 className="mb-1">{followUp.title}</h6>
          {followUp.comment && <p className="mb-1">{followUp.comment}</p>}
          <small className="text-muted d-block">
            Пользователь: {followUp.user?.username || 'неизвестно'}
          </small>
        </div>
      </div>
    </li>
  );
}

export default function TaskHistory() {
  const { taskId } = useParams();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  const [loading, setLoading] = useState(true);
  const [taskHistory, setTaskHistory] = useState(null);
  const [errorText, setErrorText] = useState('');

  React.useEffect(() => {
    axios_api
      .get(api_url + '/task_history/' + taskId, {
        headers: { Authorization: token },
      })
      .then(
        (result) => {
          const taskHistory = result.data
          setTaskHistory(taskHistory);
          setLoading(false);
        },
        (error) => {
          console.log(error);
          setTaskHistory(null);
          setErrorText('Не удалось загрузить историю задания');
          setLoading(false);
        }
      );
  }, [api_url, token, taskId]);

  if (loading) {
    return <Loader />;
  }

  const followUps = taskHistory.ticket?.follow_ups || [];

  return (
    <div className="row">
      <div className="col-9 m-3">
       
        <h3>{taskHistory.form_name}</h3>
        <p className="mt-2 mb-4">
          <Link to={`/task/${taskId}`}>Вернуться к заданию</Link>
        </p>

        {errorText && <p className="text-danger">{errorText}</p>}

        {!errorText && !taskHistory.ticket && (
          <div className="form-head p-3">
            <p className="mb-0 text-muted">Для этого задания пока нет истории действий</p>
          </div>
        )}

        {!errorText && taskHistory.ticket && (
          <div className="card mb-3">
            <div className="card-header">
              <h6 className="mb-1">{taskHistory.ticket.title}</h6>
              <small className="text-muted">Создано: {taskHistory.ticket.created}</small>
            </div>

            {followUps.length > 0 ? (
              <ul className="list-group list-group-flush">
                {followUps.map((followUp) => (
                  <TaskHistoryFollowUp key={followUp.id} followUp={followUp} />
                ))}
              </ul>
            ) : (
              <div className="card-body">
                <p className="mb-0 text-muted">В истории пока нет событий</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
